var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout-header",
    { staticClass: "mc-header" },
    [
      _c("div", { staticClass: "header-title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.currentSession.deptName == "广西开放大学"
                ? "广西开放大学（广西信息职业技术学院）"
                : _vm.currentSession.deptName
            ) +
            "-网络舆情监控系统 "
        )
      ]),
      _c("img", {
        staticClass: "header-logo",
        attrs: { src: require("@/images/logo.png") }
      }),
      _c(
        "a-row",
        { staticStyle: { width: "100%" } },
        [
          _c("a-col", { attrs: { span: 12 } }),
          _c(
            "a-col",
            {
              staticStyle: { "text-align": "right", "padding-right": "20px" },
              attrs: { span: 12 }
            },
            [
              _c(
                "a-dropdown",
                [
                  _c(
                    "a",
                    {
                      staticClass: "ant-dropdown-link",
                      staticStyle: { color: "white" },
                      attrs: { href: "#" }
                    },
                    [
                      _vm._v(
                        " 您好；" +
                          _vm._s(
                            _vm.currentSession.name
                              ? _vm.currentSession.name
                              : _vm.currentSession.userName
                          ) +
                          " "
                      ),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  ),
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/logout" } },
                            [
                              _c("a-icon", { attrs: { type: "logout" } }),
                              _vm._v("注销登录 ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }